import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { GenericObject, Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import {
  StandingOrder,
  StandingOrderDetails,
  SweepOrder,
  SweepOrderDetails,
} from '../../domain/RecurringOrder/entities';

export enum RecurringOrderTabs {
  standing = 'STANDING',
  sweep = 'SWEEP',
}

export enum RecurringOrdersActionEnum {
  viewDetails = 'VIEW_DETAILS',
  cancel = 'CANCEL',
}

export enum RecurringOrdersSubmitActionEnum {
  cancel = 'CANCEL',
  pause = 'PAUSE',
}

export type RecurringOrdersState = {
  isStandingOrderSelected: boolean;
  standingOrders: Nullable<StandingOrder[]>;
  sweepOrders: Nullable<SweepOrder[]>;
  isLoadingStandingOrders: boolean;
  isLoadingSweepOrders: boolean;
  standingOrdersError?: AxiosError<APIGatewayResponse<unknown>, any>;
  sweepOrdersError?: AxiosError<APIGatewayResponse<unknown>, any>;
  selectedRecurringOrdersTab: RecurringOrderTabs;
  onSelectRecurringOrdersTab: (tab: RecurringOrderTabs) => void;
  recurringOrderAction: Nullable<RecurringOrdersActionEnum>;
  isLoadingCancelRecurringOrder: boolean;
  cancelRecurringOrderError?: AxiosError<APIGatewayResponse<unknown>, any>;
  isLoadingViewDetailsRecurringOrder: boolean;
  viewDetailsRecurringOrderError?: AxiosError<APIGatewayResponse<unknown>, any>;
  onRecurringOrderAction: (
    selectedStandingOrder: StandingOrder | SweepOrder,
    action: RecurringOrdersActionEnum,
  ) => void;
  selectedRecurringOrder: Nullable<StandingOrder | SweepOrder>;
  onResetSelectedRecurringOrder: () => void;
  cancelRecurringOrderData: Nullable<GenericObject>; // TODO add correct type
  viewRecurringOrderDetailsData: Nullable<StandingOrderDetails | SweepOrderDetails>;
  recurringOrderSubmitAction: Nullable<RecurringOrdersSubmitActionEnum>;
  onRecurringOrderSubmitAction: (action: RecurringOrdersSubmitActionEnum) => void;
  onDownloadOption: (type: Nullable<String>) => void;
};

export enum RecurringOrdersContextActionTypes {
  SetSelectedRecurringOrdersTab = '@@RecurringOrders/SET_SELECTED_RECURRING_ORDERS_TAB',
  SetSelectedRecurringOrder = '@@RecurringOrders/SET_SELECTED_RECURRING_ORDER',
  ResetSelectedRecurringOder = '@@RecurringOrders/RESET_SELECTED_RECURRING_ORDER',
  SetRecurringOrderSubmitAction = '@@RecurringOrders/SET_RECURRING_ORDER_SUBMIT_ACTION',
}
